// Colour swatches on the list card (snippets/list-card-product.liquid).
// A swatch click re-renders the whole card for the sibling colour through the
// Section Rendering API (sections/list-card-product-swatch.liquid) and swaps it
// in place. The whole card is replaced, not patched, so the image, title, price,
// variant select, add-to-cart form and the swatch row all belong to the new
// product. Any failure falls back to following the swatch's link to the PDP.
// A wishlist-mode card (data-wishlist-mode, Complete the Look in the wishlist
// lightbox) is re-rendered by sections/list-card-product-swatch-wishlist.liquid
// instead, so it keeps its ADD TO WISHLIST bar.
//
// The snippet includes this file once per card, so it registers only once and
// listens on document, which also covers cards swapped in later.
(function () {
  if (window.__mnListCardSwatches) return;
  window.__mnListCardSwatches = true;

  const SECTION_ID = 'list-card-product-swatch';
  const WISHLIST_SECTION_ID = 'list-card-product-swatch-wishlist';
  const cache = new Map();

  function sectionFor(cardRoot) {
    return cardRoot && cardRoot.hasAttribute('data-wishlist-mode') ? WISHLIST_SECTION_ID : SECTION_ID;
  }

  function fetchCard(handle, sectionId) {
    const key = `${sectionId}:${handle}`;
    if (!cache.has(key)) {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const request = fetch(`${root}products/${encodeURIComponent(handle)}?section_id=${sectionId}`)
        .then((response) => {
          if (!response.ok) throw new Error(`Section request failed: ${response.status}`);
          return response.text();
        })
        .catch((error) => {
          cache.delete(key);
          throw error;
        });
      cache.set(key, request);
    }
    return cache.get(key);
  }

  // The response is rendered with the swatch section's id and no ctl- prefix.
  // Rewrite the ids the card derives from them (wrapper, form, variant select,
  // its label) to the ones the replaced card had, so ids stay unique per
  // section and form="" references still resolve.
  function buildCard(html, oldRoot, productId, responseSectionId) {
    const sectionId = oldRoot.dataset.sectionId;
    const formPrefix = oldRoot.dataset.formPrefix || '';
    const patched = html
      .split(`form-${responseSectionId}-${productId}`).join(`${formPrefix}form-${sectionId}-${productId}`)
      .split(`-${responseSectionId}-${productId}`).join(`-${sectionId}-${productId}`);

    const parsed = new DOMParser().parseFromString(patched, 'text/html');
    const parsedRoot = parsed.querySelector('[data-list-card-root]');
    if (!parsedRoot) return null;

    // importNode so <list-card-product> and <product-form> upgrade on insert.
    const newRoot = document.importNode(parsedRoot, true);
    newRoot.dataset.sectionId = sectionId;
    newRoot.dataset.formPrefix = formPrefix;

    // The inline variant is a render parameter the section cannot know about.
    const oldCard = oldRoot.querySelector('.list-card-product');
    const newCard = newRoot.querySelector('.list-card-product');
    if (oldCard && newCard && oldCard.classList.contains('list-card-product--inline')) {
      newCard.classList.add('list-card-product--inline');
    }
    return newRoot;
  }

  function isPlainClick(event) {
    return event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey;
  }

  // Start the request as the finger or pointer goes down, ahead of the click.
  document.addEventListener('pointerdown', (event) => {
    const swatch = event.target.closest('[data-list-card-swatch]');
    if (swatch && swatch.dataset.productHandle) {
      fetchCard(swatch.dataset.productHandle, sectionFor(swatch.closest('[data-list-card-root]'))).catch(() => {});
    }
  }, { passive: true });

  document.addEventListener('click', (event) => {
    const swatch = event.target.closest('[data-list-card-swatch]');
    if (!swatch || !isPlainClick(event)) return;

    const oldRoot = swatch.closest('[data-list-card-root]');
    const { productHandle: handle, productId } = swatch.dataset;
    if (!oldRoot || !handle || !productId) return;

    event.preventDefault();
    const sectionId = sectionFor(oldRoot);

    // A later click on the same card wins over a request still in flight.
    const token = String(Date.now() + Math.random());
    oldRoot.dataset.swatchToken = token;
    oldRoot.setAttribute('aria-busy', 'true');

    fetchCard(handle, sectionId)
      .then((html) => {
        if (!oldRoot.isConnected || oldRoot.dataset.swatchToken !== token) return;

        const newRoot = buildCard(html, oldRoot, productId, sectionId);
        if (!newRoot) throw new Error('Card missing from section response');

        oldRoot.replaceWith(newRoot);

        if (window.convertCurrency) window.convertCurrency(newRoot);

        // Keep keyboard focus on the swatch row rather than dropping it to <body>.
        const active = newRoot.querySelector('.list-card-product__swatch.is-active');
        if (active && swatch === document.activeElement) {
          active.setAttribute('tabindex', '-1');
          active.focus({ preventScroll: true });
        }

        newRoot.dispatchEvent(new CustomEvent('list-card-product:swatch-change', {
          bubbles: true,
          detail: { handle, productId },
        }));
      })
      .catch((error) => {
        if (oldRoot.dataset.swatchToken !== token) return;
        console.warn('List card swatch swap failed, opening the PDP instead:', error);
        window.location.href = swatch.href;
      })
      .finally(() => {
        oldRoot.removeAttribute('aria-busy');
      });
  });
})();
